import { render, staticRenderFns } from "./OrderConsole.vue?vue&type=template&id=365c8e09&scoped=true"
import script from "./OrderConsole.vue?vue&type=script&lang=js"
export * from "./OrderConsole.vue?vue&type=script&lang=js"
import style0 from "./OrderConsole.vue?vue&type=style&index=0&id=365c8e09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365c8e09",
  null
  
)

export default component.exports